// 新着情報の一覧データ。FVのティッカー（最新1件）と新着一覧ページで共有する。
// 記事を追加するときは、この配列に1件追加し、対応する詳細ページを src/pages/news/ に作成する。
export const newsList = [
  {
    date: "2026.06.16",
    title: "Jiteraとセールスパートナー契約を締結しました",
    path: "/news/jitera-partnership/",
    excerpt:
      "AIコンテキストプラットフォームの活用で、企業のDX・AI化を高速化します。",
    image: "",
  },
];
